module.exports = __webpack_public_path__ + "img/banner.90ff05c4.png";